module.exports = __webpack_public_path__ + "img/store_YT.071090c1.svg";